import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import useAlertStore from "store/alert";
import "../modal/modal.scss";

export default function Alert() {
  const { t } = useTranslation();
  const {
    isOpen,
    inner,
    innerHtml,
    chkBnt,
    cnclBtn,
    chkTxt,
    setIsOpen,
    onSetConfirm,
  } = useAlertStore();
  const btnRef = useRef<HTMLButtonElement>(null);
  const divRef = useRef<HTMLDivElement>(null);

  const onConfirm = () => {
    setIsOpen(false);
    onSetConfirm && onSetConfirm();
  };

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    isOpen && (
      <section>
        {createPortal(
          <section className={`modal-layout`}>
            <div className="modal center">
              <div
                className="h-full text-xs font-bold text-center p-4 leading-5"
                ref={divRef}
              >
                {inner &&
                  inner.length > 0 &&
                  inner.split("/").map((text, index) => {
                    return <p key={index}>{text}</p>;
                  })}
                {innerHtml && innerHtml}
              </div>
              <div className="flex justify-center gap-3">
                <button
                  ref={btnRef}
                  className="btn bg-red-400 px-2"
                  onClick={onConfirm}
                >
                  {t(chkTxt)}
                </button>
                <button
                  hidden={!cnclBtn}
                  className="btn bg-gray-300"
                  onClick={onClose}
                >
                  {t("btn_cancel")}
                </button>
              </div>
            </div>
          </section>,
          document.body
        )}
      </section>
    )
  );
}
